import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DropDownList } from "components/common/DropDownList/DropDownList";
import { SortIcon } from "components/common/Icons/SortIcon";
import { SmallContainer } from "components/common/SmallContainer/SmallContainer";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { Translate } from "components/common/Translate/Translate";
import type { ReactNode } from "react";
import type { Sort as SortType } from "store/types/sort";
import { useSort } from "./useSort";
import { getSortListItems } from "../../BottomMenu/Content/Sort/Sort";

export const Sort = () => {
    const { isOpen, open, close, handleClick, sort: currentSort } = useSort();

    return (
        <DropDownList
            callback={handleClick}
            items={getSortListItems(currentSort)}
            isOpen={isOpen}
            open={open}
            close={close}
        >
            <ToolTip text={capitalize(`${translateFunc("filter")}`)}>
                <SmallContainer
                    className={`cursor-pointer flex items-center justify-center ${
                        isOpen ? "bg-irGray-200 dark:bg-darkSurface-200" : "bg-white dark:bg-darkSurface-300"
                    } hover:bg-irGray-200 dark:hover:bg-darkSurface-200 border border-irGray-400 dark:border-darkSurface-100
                    rounded-xl p-2.5`}
                    data-testid={`sort-list-opener`}
                >
                    <SortIcon />
                </SmallContainer>
            </ToolTip>
        </DropDownList>
    );
};

export const SortItem = ({
    sort,
    currentSort,
    children,
    isLast,
}: {
    sort: SortType;
    currentSort: SortType | null;
    children: ReactNode;
    isLast?: boolean;
}) => (
    <div
        className={`capitalize hover:bg-irGray-200 select-none py-2 pl-6 px-24 ${
            sort === currentSort ? "bg-irGray-200 dark:bg-darkSurface-300" : "bg-white dark:bg-darkSurface-200"
        } ${typeof isLast === "undefined" || !!isLast === false ? "border-b border-b-irGray-400" : ""}
        dark:hover:bg-darkSurface-300`}
        data-testid={`sort-${sort}`}
    >
        {children}
    </div>
);
